import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

import clientTvIcon from '../../../../static/images/icons/tv-equip.svg';

const ClientTvContainer = styled.div`    
    border-radius: 4px;
    min-height: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 60px 0 60px;
    @media (max-width: 860px) {
        padding: 120px 0 30px;
    }
`;

const ItemContainer = styled.div`
    background: ${ COLORS.white };    
    border: 1px solid ${ COLORS.outlineGrey };
    width: 100%;
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    margin-bottom: 10px;
    height: 78px;
    @media (max-width: 1100px) {
        height: 58px;
    }
    @media (max-width: 500px) {
        height: 48px;
    }
`;
const ItemIcon = styled.div`
    display: flex;
    background: ${ COLORS.grey } url(${ clientTvIcon }) center center no-repeat;
    width: 116px;
    flex-shrink: 0;    
    border-radius: 4px 0 0 4px;
    @media (max-width: 1500px) {
        width: 78px;
        background-size: 40px 27px;
    }
    @media (max-width: 1100px) {
        width: 58px;
        background-size: 30px 20px;
    }
    @media (max-width: 500px) {
        width: 48px;
        background-size: 26px 18px;
    }
`;
const ItemTitle = styled.div`
    display: flex;
    align-items: center;
    padding-left: 40px;
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 20px;
    @media (max-width: 1100px) {
        font-size: 14px;
        line-height: 18px;        
        padding-left: 30px;
    }
    @media (max-width: 500px) {
        font-size: 12px;
        line-height: 18px;
        padding-left: 15px;
    }
`;
const ClientTvTitle = styled.div`
    font-size: 44px;
    line-height: 56px;
    margin: 0 0 40px;
    @media (max-width: 1500px) {
        font-size: 32px;
        line-height: 40px;
        margin: 0 0 30px;
    }
    @media (max-width: 1100px) {
        font-size: 24px;
        line-height: 32px;      
        margin: 0 0 20px;
    }
    @media (max-width: 500px) {
        font-size: 20px;
        line-height: 28px;
        margin: 0 0 15px;
    }    
`;

export const ClientTv = (props) => {
    const { clientTv } = props;
    return (
        <ClientTvContainer>
            <ClientTvTitle>Мое оборудование для ТВ</ClientTvTitle>
            {
                clientTv.map((item, index) => <ItemContainer key={ index }>
                    <ItemIcon/>
                    <ItemTitle>{ item.material_name } | { item.cost_type } ({ item.count_materials }шт.)</ItemTitle>
                </ItemContainer>)
            }
        </ClientTvContainer>
    );
};
